/**
 * 『コマ割』画面に引き渡す値を格納するVO
 *
 * @export KYMW1403OutputModel
 * @class KYMW1403OutputModel
 */
export class KYMW1403OutputModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 会員生協コード
   */
  public coopCode = String('');

  /**
   * ページID
   */
  public pageId = String('');

  /**
   * ページ番号
   */
  public pageNum = String('');
}
